import FormattedMessage from 'I18n/components/FormattedMessage';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { View } from 'foundations-components/components/View';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { Progress } from 'foundations-components/transitional/components/Progress';
import { InfoIcon } from 'foundations-assets/icons/components/InfoIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const InAppCountDisplay = ({
  upgradeKey,
  currentUsage,
  usageLimit,
  dataTestId,
  usageRemaining
}) => {
  const i18nKey = isValidI18nKey(`usageLimitCounter.${upgradeKey}.counter`) ? `usageLimitCounter.${upgradeKey}.counter` : 'usageLimitCounter.defaultCopy.counter';
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(View, {
      marginBlockStart: "50",
      inlineSize: "200px",
      children: /*#__PURE__*/_jsx(Progress, {
        marginInlineEnd: "200",
        marginBlockEnd: "0",
        use: "warning",
        value: currentUsage / usageLimit * 100,
        "aria-label": "Progress Bar"
      })
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey,
      options: {
        currentUsage,
        usageLimit,
        usageRemaining
      },
      "data-test-id": dataTestId
    }), /*#__PURE__*/_jsx(IconHolder, {
      icon: InfoIcon,
      color: "icon-core-subtle",
      padding: "0",
      marginInlineStart: "100",
      size: "300"
    })]
  });
};
export default InAppCountDisplay;